const staffFullname = staff => {
  if (!staff) return null

  return `${staff.salutation || ""} ${staff.forename || ""} ${staff.surname || ""}`.replace(/  +/g, " ").trim()
}

export default staffFullname
